import { CategoriesApi } from '../types/api/categories-api';
import { NetworkResponse } from '../types/services/request.types';
import { RequestHandler } from './requestHandler.service';
import { UrlBuilder } from './urlBuilder.service';
import { HMC_PAGE_PATH, HMC_VISIBILITY_PATH } from '../constants/replatform/hmc-endpoint-url';
import { HmcCategoriesRequestParams } from '../types/api-params/hmcCategories';
import { HmcBannerRequestParams } from '../types/api-params/hmcBanner';
import { THMCBanner } from '../types/hmc';

export class HmcCategoriesHandler extends RequestHandler {
  api = {
    target: 'hmc-categories',
    default: 'hmc-default',
  };

  fetchCategoriesWithHMC(
    parameters: HmcCategoriesRequestParams,
  ): NetworkResponse<CategoriesApi.CategoriesWithHmc[]> {
    return this.get<CategoriesApi.CategoriesWithHmc[]>(
      UrlBuilder.buildHmcURL({
        ...parameters,
        queryParams: {
          pimIds: parameters.pimIds,
          hmcBanner: parameters.hmcBanner,
          platform: parameters.platform,
        },
        endPointName: HMC_VISIBILITY_PATH,
        resources: HMC_PAGE_PATH.CATEGORY_PAGE,
      }),
    );
  }

  fetchSingleCategoryWithHMC(
    parameters: HmcBannerRequestParams,
  ): NetworkResponse<THMCBanner> {
    return this.get<THMCBanner>(
      UrlBuilder.buildHmcURL({
        ...parameters,
        endPointName: HMC_VISIBILITY_PATH,
        resources: HMC_PAGE_PATH.CATEGORY_PAGE,
      }),
    );
  }
}

export const HmcCategories = new HmcCategoriesHandler();
